import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

function DelayedRender(props: { delay?: number; children?: ReactNode }): JSX.Element | null {
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        if (show) {
            return;
        }
        setTimeout(() => {
            setShow(true);
        }, props.delay ?? 0);
    });

    return show ? <>{props.children}</> : null;
}

export default DelayedRender;
